<div shrResized
    id="em-dashboard"
    (resized)="onContentResize($event)"
    #mainContent
    class="main-content scroll-content">
    <router-outlet (activate)="onActivate($event)"></router-outlet>
</div>